module.exports = __webpack_public_path__ + "static/media/mlf_logo.eeff08d7.svg";